// import React, { useEffect, useState, useRef } from 'react';
// import styles from './scss/orchestrate.module.scss';
// import { getLycaSegementationBasedOnCustomer } from '../../apiservice/aiLycaPilot';
// import { assets } from '../../styles/assets/assets';
// const TypingText = ({
//     text,
//     onDone,
//     speed = 50,
// }: {
//     text: string;
//     onDone?: () => void;
//     speed?: number;
// }) => {
//     const [displayedText, setDisplayedText] = useState('');

//     useEffect(() => {
//         let i = 0;
//         setDisplayedText('');
//         const interval = setInterval(() => {
//             setDisplayedText(text.slice(0, i + 1));
//             i++;
//             if (i === text.length) {
//                 clearInterval(interval);
//                 onDone?.();
//             }
//         }, speed);

//         return () => clearInterval(interval);
//     }, [text, speed, onDone]);

//     return <>{displayedText}</>;
// };
// const Orchestrate2 = ({ onComplete }: { onComplete?: () => void }) => {
//     const phaseOrder = ['title', 'desc', 'chart', 'maindesc','rev2','avg1','avg2'];
//     const [segmentdata, setSegmentData] = useState<any>([]);
//     const [visibleSection, setVisibleSection] = useState(0);
//     const [phase, setPhase] = useState(phaseOrder[0]);
//     const chartRefs = useRef<(HTMLDivElement | null)[]>([]);
//     const fieldRefs = useRef<Record<string, HTMLDivElement | null>>({});

//     useEffect(() => {
//         const fetchData = async () => {
//             const body = { fromYear: "2024", toYear: "2025", domainId: " " };
//             try {
//                 const res = await getLycaSegementationBasedOnCustomer(body);
//                 if (res?.data?.statusCode === 200) {
//                     setSegmentData(res.data.response);
//                 }
//             } catch (error) {
//                 console.error('Error fetching segmentation target data:', error);
//             }
//         };



//         fetchData(); // ✅ call it
//     }, []);

//     const clusterDescriptions: Record<number, string> = {
//         0: "Heavy data usage but almost no voice, low balance, and small top-ups – typical “smartphone-only” prepaid behavior",
//         1: "Extremely light users with almost no spend or engagement",
//         2: "Balanced data + voice usage and some installment behavior; mid-spend segment",
//         3: "Consume large amounts of both data and voice; maintain healthy balances; willing to pay for premium usage",
//         4: "Keep large prepaid balances, under-utilize bundles, buy more than they use – strong “roll-over” candidates",
//         5: "Similar to Heavy data-voice power users but with higher bundle spend and balances – premium subscribers",
//         6: "High spenders with instalments, likely family or business plans; prefer smoothing payments"
//     };

//     const clusterHeading: Record<number, string> = {
//         0: "DataLite ",
//         1: "IdleSaver",
//         2: "EverydayFlex ",
//         3: "MaxStream ",
//         4: "BundleBank ",
//         5: "EliteEdge ",
//         6: "PrimePay "
//     };

//     const carouselItems = segmentdata.map((item: any) => {
//         return {
//             count: item.TotalCustomers.toLocaleString(),
//             countTitle: "Customers",
//             heading: `${clusterHeading[item.Cluster] || "Segment information not available"}`,
//             headingDesc: clusterDescriptions[item.Cluster] || "Segment information not available.",
//             avgRevenueCount: `${Number(item.avgerage_revenue).toLocaleString(undefined, {
//                 minimumFractionDigits: 2,
//                 maximumFractionDigits: 2
//             })} Kr`,
//             clvCount: `${Number(item.avgerage_revenue).toLocaleString(undefined, {
//                 minimumFractionDigits: 0,
//                 maximumFractionDigits: 0
//             })} Kr`
//         };
//     });


//     console.log('carouselItems ==', carouselItems);
//     console.log("carouselItems ==", carouselItems);

//     const sections = carouselItems.map((data: any) => ({
//         title: data.count,
//         desc: data.countTitle,
//         chart: data.heading,
//         maindesc: data.headingDesc,
//         rev1: <img src={assets.email_icon} alt="Revenue Icon" />,
//         rev2: "Email",
//         avg1: "Whatsapp",
//         avg2: `${data.clvCount}`,
//     }));

//     console.log("sections ==", sections);


//     // Scroll when section changes
//     useEffect(() => {
//         chartRefs.current[visibleSection]?.scrollIntoView({
//             behavior: 'smooth',
//             block: 'center',
//         });
//     }, [visibleSection]);

//     // Scroll when phase changes
//     useEffect(() => {
//         const key = `${visibleSection}-${phase}`;
//         fieldRefs.current[key]?.scrollIntoView({
//             behavior: 'smooth',
//             block: 'center',
//         });
//     }, [phase, visibleSection]);

//     useEffect(() => {
//         setPhase(phaseOrder[0]);
//     }, [visibleSection]);

//     const onTypingDone = () => {
//         const currentIndex = phaseOrder.indexOf(phase);
//         if (currentIndex < phaseOrder.length - 1) {
//             setPhase(phaseOrder[currentIndex + 1]);
//         } else {
//             if (visibleSection < sections.length - 1) {
//                 setVisibleSection((prev) => prev + 1);
//             } else {
//                 onComplete?.();
//             }
//         }
//     };

//     const renderField = (
//         section: (typeof sections)[0],
//         field: keyof typeof section,
//         fieldPhase: string,
//         sectionIndex: number
//     ) => {
//         const isCurrent = sectionIndex === visibleSection;
//         const currentPhaseIndex = phaseOrder.indexOf(phase);
//         const refKey = `${sectionIndex}-${fieldPhase}`;

//         if (isCurrent) {
//             if (phase === fieldPhase) {
//                 return (
//                     <div ref={(el) => (fieldRefs.current[refKey] = el)}>
//                         <TypingText text={section[field]} onDone={onTypingDone} />
//                     </div>
//                 );
//             }
//             if (currentPhaseIndex > phaseOrder.indexOf(fieldPhase)) {
//                 return section[field];
//             }
//             return ''; // Not yet started
//         }

//         return section[field]; // Past sections → show instantly
//     };
//     return (
//         <>
//             <div className={styles.orchestrateo}>
//                 <h3>Live Updates</h3>
//                 <p>Micro-view of yesterday’s results by channel and overall.</p>
//                 <div className={styles.recmain}>
//                     {sections.map((section: any, i: React.Key | null | undefined) => {
//                         if (i > visibleSection) return null;

//                         return (
//                             <div
//                                 key={i}
//                                 className={styles.recmainblock}
//                                 ref={(el) => (chartRefs.current[i] = el)}
//                             >
//                                 <div className={styles.recmainblocktop}>
//                                     <h4>{renderField(section, 'title', 'title', i)}</h4>
//                                     <p>{renderField(section, 'desc', 'desc', i)}</p>
//                                 </div>

//                                 <div className={styles.recmainblockmid}>
//                                     <p>{renderField(section, 'chart', 'chart', i)}</p>
//                                     <p>{renderField(section, 'maindesc', 'maindesc', i)}</p>
//                                 </div>

//                                 <div className={styles.recmainblockbottom}>
//                                     <div className={styles.recmainblockbottomleft}>
//                                         {/* {phaseOrder.indexOf(phase) > phaseOrder.indexOf('maindesc') && (
//                                             <img src={assets.email_icon} alt="Revenue Icon" />
//                                         )} */}
//                                         {/* <p>{renderField(section, 'rev1', 'rev1', i)}</p> */}
//                                         <p>{renderField(section, 'rev2', 'rev2', i)}</p>
//                                     </div>
//                                     <div className={styles.recmainblockbottomright}>
//                                         {/* {phaseOrder.indexOf(phase) > phaseOrder.indexOf('rev1') && (
//                                             <img src={assets.whatsapp_icon} alt="Revenue Icon" />
//                                         )} */}
//                                         {/* {phaseOrder.indexOf(phase) > phaseOrder.indexOf('rev1') && ( */}
//                                             <p>{renderField(section, 'avg2', 'avg2', i)}</p>
//                                             <p>{renderField(section, 'avg1', 'avg1', i)}</p>
//                                         {/* )} */}
//                                     </div>
//                                 </div>
//                             </div>
//                         );
//                     })}
//                 </div>
//             </div>
//         </>
//     )
// }
// export default Orchestrate2;


import React, { useEffect, useState, useRef } from 'react';
import styles from './scss/orchestrate.module.scss';
import { assets } from '../../styles/assets/assets';

const TypingText = ({
    text,
    onDone,
    speed = 50,
}: {
    text: string;
    onDone?: () => void;
    speed?: number;
}) => {
    const [displayedText, setDisplayedText] = useState('');

    useEffect(() => {
        if (!text) return;
        let i = 0;
        setDisplayedText('');
        const interval = setInterval(() => {
            setDisplayedText(text.slice(0, i + 1));
            i++;
            if (i === text.length) {
                clearInterval(interval);
                onDone?.();
            }
        }, speed);

        return () => clearInterval(interval);
    }, [text, speed, onDone]);

    return <>{displayedText}</>;
};

const Orchestrate2 = ({ onComplete }: { onComplete?: () => void }) => {
    // const phaseOrder = ['title', 'desc', 'chart', 'maindesc', 'rev2', 'avg1'];
    const phaseOrder = ['title', 'desc', 'chart', 'maindesc'];
    const [visibleSection, setVisibleSection] = useState(0);
    const [phase, setPhase] = useState(phaseOrder[0]);
    const chartRefs = useRef<(HTMLDivElement | null)[]>([]);
    const fieldRefs = useRef<Record<string, HTMLDivElement | null>>({});

    // ✅ Static data (no API)
    const sections = [
        {
            title: "Canary graduated; +1.9 pp",
            desc: "5% canary (12h) was stable; cap increase graduated.",
            chart: "Reached ~18k users; +1.9 pp vs control.",
            maindesc: "Guardrails intact; no fatigue/fairness flags.",
        }
    ];

    useEffect(() => {
        chartRefs.current[visibleSection]?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        });
    }, [visibleSection]);

    useEffect(() => {
        const key = `${visibleSection}-${phase}`;
        fieldRefs.current[key]?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        });
    }, [phase, visibleSection]);

    useEffect(() => {
        setPhase(phaseOrder[0]);
    }, [visibleSection]);

    const onTypingDone = () => {
        const currentIndex = phaseOrder.indexOf(phase);
        if (currentIndex < phaseOrder.length - 1) {
            setPhase(phaseOrder[currentIndex + 1]);
        } else {
            if (visibleSection < sections.length - 1) {
                setVisibleSection((prev) => prev + 1);
            } else {
                onComplete?.();
            }
        }
    };

    const renderField = (
        section: (typeof sections)[0],
        field: keyof typeof section,
        fieldPhase: string,
        sectionIndex: number
    ) => {
        const isCurrent = sectionIndex === visibleSection;
        const currentPhaseIndex = phaseOrder.indexOf(phase);
        const refKey = `${sectionIndex}-${fieldPhase}`;

        if (isCurrent) {
            if (phase === fieldPhase) {
                return (
                    <div ref={(el) => (fieldRefs.current[refKey] = el)}>
                        <TypingText text={section[field] as string} onDone={onTypingDone} />
                    </div>
                );
            }
            if (currentPhaseIndex > phaseOrder.indexOf(fieldPhase)) {
                return section[field];
            }
            return '';
        }

        return section[field];
    };

    return (
        <div className={styles.orchestrateo}>
            <h3>Live Updates</h3>
            <p>Micro-view of yesterday’s results by channel and overall.</p>

            <div className={styles.recmain}>
                {sections.map((section, i) => (
                    <div
                        key={i}
                        className={styles.recmainblock}
                        ref={(el) => (chartRefs.current[i] = el)}
                    >
                        <div className={styles.recmainblocktop}>
                            <h4>{renderField(section, 'title', 'title', i)}</h4>
                            <p>{renderField(section, 'desc', 'desc', i)}</p>
                            <p>{renderField(section, 'chart', 'chart', i)}</p>
                            <p>{renderField(section, 'maindesc', 'maindesc', i)}</p>
                        </div>

                       
                        <div className={styles.social}>
                                <div className={styles.socialinner}><img src={assets.email_icon} alt="email_icon" /> Email</div>
                                <div className={styles.socialinner}><img src={assets.whatsapp_icon} alt="whatsapp_icon" /> Whatsapp</div>
                            </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Orchestrate2;
